import React from 'react';

import LinkWithPrevLocation from '@common/react/components/UI/LinkWithPrevLocation/LinkWithPrevLocation';
import Transmutation from '@common/react/components/Forms/Transmutation';
import Avatar from '@common/react/components/Forms/Avatar';

import {
	SearchObjectType,
	SearchObjectTypeColor,
	SearchObjectTypePathName,
} from '@app/components/UI/SearchModal/index';
import { CustomItem } from '@app/components/Layouts/DashboardLayout/Menu';

interface Props {
	item: any;
	search: string;
	isSelected?: boolean;
	onSelect?: (item) => void;
	allowTransmutation?: boolean;
	userLoadingId: number;
}

const SearchModalItem: React.FC<Props> = (props) => {
	const {
		item,
		isSelected,
		onSelect,
		search,
		allowTransmutation,
		userLoadingId,
	} = props;
	const ref = React.useRef<HTMLLIElement>(null);
	React.useEffect(() => {
		if (isSelected && item?.scrollIntoView) {
			item.scrollIntoView = undefined;
			ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}, [isSelected]);

	if (!item.id) {
		return <CustomItem
			search={search}
			defaultOpen
			className={isSelected ? 'search-modal-item__selected' : ''}
			key={`${item.name}${item.path}`}
			item={item}
			withChildren={item.children}
			basePath={item.basePath || ''}
			forceOpen
			liRef={ref}
			additional={<i className="fa fa-level-down" />}
			onMouseMove={() => !isSelected && !item.group && onSelect && onSelect(item)}
		/>;
	}

	const firstName = item.name.split(' ')?.[0];
	const lastName = item.name.split(' ')?.[1];

	return <li
		ref={ref}
		className={`search-modal-item ${isSelected ? 'search-modal-item__selected' : ''}`}
		onMouseMove={() => !isSelected && onSelect && onSelect(item)}
	>
		<LinkWithPrevLocation
			style={{ backgroundColor: SearchObjectTypeColor[item.type] }}
			to={`/${SearchObjectTypePathName[item.type]}-editor/${item.id}`}
		>
			<span>
				<div className="search-modal-item__avatar">
					<Avatar
						type=""
						object={item}
						readonly
						className="avatar-container"
						showOpenIcon={false}
						showDownload={false}
						withModal={false}
						firstName={item.type === SearchObjectType.Location ? item.name : firstName}
						lastName={item.type === SearchObjectType.Location ? '' : lastName}
					/>
				</div>
				{item.name}
			</span>
			{item.type === SearchObjectType.User && allowTransmutation ? <div
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
				}}
				className={userLoadingId === item.id ? 'isLoading loading-component' : ''}
			>
				<span>
					<Transmutation
						user={{ id: item.id } as any}
						className="search-modal-item__transmutation"
					/>
				</span>
			</div> : null}
			{isSelected && item.type !== SearchObjectType.User ? <i className="fa fa-level-down" /> : null}
		</LinkWithPrevLocation>
	</li>;
};

export default SearchModalItem;
